import * as mutationTypes from './mutation-types'
import errorsUtil from '@windsor-telecom-management/client-core/src/utils/errors'
import {contains, filter, flatten, isEmpty, map, omit, pluck} from 'underscore'

const initialState = () => ({
    errors: [],
    errorsUuid: null,
    validationErrors: {}
})

export default () => ({
    namespaced: true,
    state: initialState(),
    getters: {
        hasErrors: state => state.errors.length > 0,
        hasValidationErrors: state => !isEmpty(state.validationErrors.length),
        errors: state => state.errors,
        errorsUuid: state => state.errorsUuid,
        validationErrors: state => state.validationErrors,
        validationErrorsByUuid: state => (uuid) => {
            if (uuid !== state.errorsUuid) {
                return []
            }

            return state.validationErrors[state.errorsUuid]
        }
    },
    actions: {
        async addErrors ({commit}, data) {
            const errors = map(data, (err) => errorsUtil.mapError(err))

            commit(mutationTypes.ADD_ERRORS, errors)
            return errors
        },
        removeErrors ({commit}, uuids) {
            commit(mutationTypes.REMOVE_ERRORS, uuids)
            return Promise.resolve()
        },
        resetErrorsUuid ({commit}, uuid) {
            commit(mutationTypes.RESET_ERRORS_UUID, uuid)
            return Promise.resolve()
        },
        resetErrors ({commit}) {
            commit(mutationTypes.RESET_ERRORS)
            return Promise.resolve()
        },
        resetValidationErrors ({commit}) {
            commit(mutationTypes.RESET_VALIDATION_ERRORS)
            return Promise.resolve()
        },
        setErrors ({commit}, errors) {
            commit(mutationTypes.ADD_ERRORS, errors)
            return errors
        },
        setErrorsUuid ({commit}, uuid) {
            commit(mutationTypes.SET_ERRORS_UUID, uuid)
            return Promise.resolve()
        }
    },
    mutations: {
        [mutationTypes.ADD_ERRORS] (state, data) {
            state.errors = [...state.errors, ...data]
            state.validationErrors = {
                ...state.validationErrors,
                [state.errorsUuid]: flatten(pluck(data, 'errors'))
            }
        },
        [mutationTypes.REMOVE_ERRORS] (state, uuids) {
            state.errors = filter(state.errors, (err) => !contains(uuids, err.uuid))
        },
        [mutationTypes.RESET_ERRORS] (state) {
            state = Object.assign(state, initialState())
        },
        [mutationTypes.RESET_ERRORS_UUID] (state, uuid) {
            if (state.errorsUuid === uuid) {
                state.errorsUuid = null
            }
        },
        [mutationTypes.RESET_VALIDATION_ERRORS] (state) {
            state.validationErrors = omit(state.validationErrors, state.errorsUuid)
        },
        [mutationTypes.SET_ERRORS_UUID] (state, uuid) {
            state.errorsUuid = uuid
        }

    }

})
